import Vue from 'vue'
import store from '@/vuex/index.js'
import Router from 'vue-router'
import Home from '@/views/Home'
import OrganizationManager from '@/views/OrganizationManager'
import DomainManager from '@/views/DomainManager'
import FacilityManager from '@/views/FacilityManager'
import PublicMediaManager from '@/views/PublicMediaManager'
import ResidentMediaManager from '@/views/ResidentMediaManager'
import KioskMediaManager from '@/views/KioskMediaManager'
import AbbySharedLibraryManager from '@/views/AbbySharedLibraryManager'
import ResidentManager from '@/views/ResidentManager'
import ResidentPlaylistManager from '@/views/ResidentPlaylistManager'
import KioskPlaylistManager from '@/views/KioskPlaylistManager'
import AbbyResidentProfileManager from '@/views/AbbyResidentProfileManager'
import AbbyKioskProfileManager from '@/views/AbbyKioskProfileManager'
import AbbyAmbientInvitationManager from '@/views/AbbyAmbientInvitationManager'
import AbbyExpressionManager from '@/views/AbbyExpressionManager'
import MessageManager from '@/views/MessageManager'
import GenieManualManager from '@/views/GenieManualManager'
import GeniePromotionalMediaManager from '@/views/GeniePromotionalMediaManager'
import MessagePurges from '@/views/MessagePurges'
import UserEvents from '@/views/UserEvents'
import ResidentEvents from '@/views/ResidentEvents'
import KioskEvents from '@/views/KioskEvents'
import PlaylistEvents from '@/views/PlaylistEvents'
import KioskEmailManager from '@/views/KioskEmailManager'
import AbbyUpdateZipManager from '@/views/AbbyUpdateZipManager'
import KioskKeyTagMapper from '@/views/KioskKeyTagMapper'

// temporary (for tammy)
import UnupdatedAbbys from '@/views/UnupdatedAbbys'
import UpdateOverrideAbbys from '@/views/UpdateOverrideAbbys'

// import CiraStats from '@/views/CiraStats'

// user manager portals
import AdminUserManager from '@/views/UserManagerPortals/AdminUserManager'
import AbbyKioskParticpants from '@/views/UserManagerPortals/AbbyKioskParticpants'
import AbbyResidentFacilitators from '@/views/UserManagerPortals/AbbyResidentFacilitators'
import GenieKioskManagers from '@/views/UserManagerPortals/GenieKioskManagers'
import GenieKioskResidentContacts from '@/views/UserManagerPortals/GenieKioskResidentContacts'
import GenieResidentContacts from '@/views/UserManagerPortals/GenieResidentContacts'

import ConfigManager from '@/views/ConfigManager'
import KioskManager from '@/views/KioskManager'
import AbbyActivityManager from '@/views/AbbyActivityManager'
import ResidentDashboard from '@/views/ResidentDashboard'
import ResidentMetrics from '@/views/ResidentMetrics'
import KioskDashboard from '@/views/KioskDashboard'
import AdminDashboard from '@/views/AdminDashboard'
import Callback from '@/views/Callback'
import Authorize from '@/views/Authorize'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/callback',
      name: 'Callback',
      component: Callback,
      meta: {
        requiresAuth: false,
        parentRoute: '/'
      }
    }, 
    {
      path: '/authorize',
      name: 'Authorize',
      component: Authorize,
      meta: {
        requiresAuth: false,
        parentRoute: '/'
      }
    }, 
    {
      path: '/organizationManager',
      name: 'OrganizationManager',
      component: OrganizationManager,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/domainManager',
      name: 'DomainManager',
      component: DomainManager,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/facilityManager',
      name: 'FacilityManager',
      component: FacilityManager,
      props: true,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/publicMediaManager',
      name: 'PublicMediaManager',
      component: PublicMediaManager,
      props: true,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/residentMediaManager',
      name: 'ResidentMediaManager',
      component: ResidentMediaManager,
      props: true,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/kioskMediaManager',
      name: 'KioskMediaManager',
      component: KioskMediaManager,
      props: true,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/abbySharedLibraryManager',
      name: 'AbbySharedLibraryManager',
      component: AbbySharedLibraryManager,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/residentDashboard',
      name: 'ResidentDashboard',
      component: ResidentDashboard,
      props: true,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/residentMetrics',
      name: 'ResidentMetrics',
      component: ResidentMetrics,
      props: true,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/kioskDashboard',
      name: 'KioskDashboard',
      component: KioskDashboard,
      props: true,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/adminDashboard',
      name: 'AdminDashboard',
      component: AdminDashboard,
      props: true,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/residentManager',
      name: 'ResidentManager',
      props: true,
      component: ResidentManager,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/residentPlaylistManager',
      name: 'ResidentPlaylistManager',
      component: ResidentPlaylistManager,
      props: true,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/kioskPlaylistManager',
      name: 'KioskPlaylistManager',
      component: KioskPlaylistManager,
      props: true,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/abbyResidentProfileManager',
      name: 'AbbyResidentProfileManager',
      component: AbbyResidentProfileManager,
      props: true,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/abbyKioskProfileManager',
      name: 'AbbyKioskProfileManager',
      component: AbbyKioskProfileManager,
      props: true,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/abbyAmbientInvitationManager',
      name: 'AbbyAmbientInvitationManager',
      component: AbbyAmbientInvitationManager,
      props: true,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/AbbyExpressionManager',
      name: 'AbbyExpressionManager',
      component: AbbyExpressionManager,
      props: true,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/messageManager',
      name: 'MessageManager',
      props: true,
      component: MessageManager,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/kioskEmailManager',
      name: 'KioskEmailManager',
      component: KioskEmailManager,
      props: true,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },

    // user manager portals
    {
      path: '/adminUserManager',
      name: 'AdminUserManager',
      component: AdminUserManager,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/abbyKioskParticpants',
      name: 'AbbyKioskParticpants',
      component: AbbyKioskParticpants,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/abbyResidentFacilitators',
      name: 'AbbyResidentFacilitators',
      component: AbbyResidentFacilitators,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/genieKioskManagers',
      name: 'GenieKioskManagers',
      component: GenieKioskManagers,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/genieKioskResidentContacts',
      name: 'GenieKioskResidentContacts',
      component: GenieKioskResidentContacts,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/genieResidentContacts',
      name: 'GenieResidentContacts',
      component: GenieResidentContacts,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },

    {
      path: '/configManager',
      name: 'ConfigManager',
      component: ConfigManager,
      props: true,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/kioskManager',
      name: 'KioskManager',
      component: KioskManager,
      props: true,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/abbyActivityManager',
      name: 'AbbyActivityManager',
      component: AbbyActivityManager,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/genieManualManager',
      name: 'GenieManualManager',
      component: GenieManualManager,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/geniePromotionalMediaManager',
      name: 'GeniePromotionalMediaManager',
      component: GeniePromotionalMediaManager,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/unupdatedAbbys',
      name: 'UnupdatedAbbys',
      component: UnupdatedAbbys,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/updateOverrideAbbys',
      name: 'UpdateOverrideAbbys',
      component: UpdateOverrideAbbys,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    // {
    //   path: '/CiraStats',
    //   name: 'CiraStats',
    //   component: CiraStats,
    //   meta: {
    //     requiresAuth: true,
    //     parentRoute: '/'
    //   }
    // },
    {
      path: '/messagePurges',
      name: 'MessagePurges',
      component: MessagePurges,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/userEvents',
      name: 'UserEvents',
      component: UserEvents,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/residentEvents',
      name: 'ResidentEvents',
      component: ResidentEvents,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/kioskEvents',
      name: 'KioskEvents',
      component: KioskEvents,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/playlistEvents',
      name: 'PlaylistEvents',
      component: PlaylistEvents,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/abbyUpdateZipManager',
      name: 'AbbyUpdateZipManager',
      component: AbbyUpdateZipManager,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    },
    {
      path: '/kioskKeyTagMapper',
      name: 'KioskKeyTagMapper',
      component: KioskKeyTagMapper,
      meta: {
        requiresAuth: true,
        parentRoute: '/'
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    var isAuthentcated = false
    var isValidProfile = false
    if (store !== undefined) {
      if (store.state !== undefined) {
        isAuthentcated = store.state.authenticated
        isValidProfile = store.state.profile.id !== undefined
      }
    }
    if (to.path === '/' || to.path === '/callback' || to.path === '/authorize' || (isAuthentcated && isValidProfile)) {
      return next()
    }

    // they tried to manually navigate to a page - send them Home
    store.dispatch('initRouteStack')
    router.push('/')
  } else {
    next() // don't forget to call next()!
  }
})

export default router
